"use strict";

import React from "react";

import Wprr from "wprr";

import Header from "wf/components/Header";
import Footer from "wf/components/Footer";

// import SingularPage from "./SingularPage";
export default class SingularPage extends Wprr.BaseObject {
	
	/**
	 * Constructor
	 */
	_construct() {
		super._construct();

		this.pageSettings = this.getFirstInput(Wprr.sourceReference("wprr/pageItem", "post.linkedItem.pageSettings.linkedItem.identifier.value"));
		this.headerType = this.getFirstInput(Wprr.sourceReference("wprr/pageItem", "post.linkedItem.pageSettings.linkedItem.headerType.linkedItem.identifier.value"));
		this.footerType = this.getFirstInput(Wprr.sourceReference("wprr/pageItem", "post.linkedItem.pageSettings.linkedItem.footerType.linkedItem.identifier.value"));
	}
	
	_renderMainElement() {
		//console.log("lagerkungen/SingularPage::_renderMainElement");
		
		//let heroType = this.getFirstInput(Wprr.sourceReference("wprr/pageItem", "post.linkedItem.pageSettings.linkedItem.heroType.linkedItem.identifier.value"));
		
		return <div>
			<Wprr.layout.PageDataSources loadUser={true}>
				<div>
					<Wprr.layout.admin.editorsgroup.editors.EditorsGroup>
						<Wprr.layout.admin.page.EditPage />
						<Wprr.EditableProps editableProps="overlays" overlays={[]}>
							<Wprr.OverlayArea lockHtmlScroll={true} pointerEvents={true} ref={Wprr.RefGroup.getCallback("overlays", "site")}>
								<div>
									<Header />
									<Wprr.ContentsAndInjectedComponents />
									<Footer />
								</div>
							</Wprr.OverlayArea>
						</Wprr.EditableProps>
					</Wprr.layout.admin.editorsgroup.editors.EditorsGroup>
				</div>
			</Wprr.layout.PageDataSources>
		</div>;
	}
}